import { render, staticRenderFns } from "./AdminViewBranch.vue?vue&type=template&id=31cf50f1&scoped=true&"
import script from "./AdminViewBranch.vue?vue&type=script&lang=js&"
export * from "./AdminViewBranch.vue?vue&type=script&lang=js&"
import style0 from "./AdminViewBranch.vue?vue&type=style&index=0&id=31cf50f1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cf50f1",
  null
  
)

export default component.exports